import { joinCn } from '@/component/UI/util';

const style = {
  vModal: joinCn(
    'flex flex-col  ',
    'w-[var(--modal-width)]',
    'bg-white',
    'shadow-sm',
  ),

  vModalBaseInner: joinCn('px-4'),

  get vModalHeader() {
    return joinCn(
      'flex items-center justify-between',
      'py-2',
      'text-body-l leading-normal font-normal text-black',
      this.vModalBaseInner,
    );
  },

  vModalClose: joinCn('h-6 w-6 cursor-pointer text-gray-400'),

  get vModalBody() {
    return joinCn('py-4', this.vModalBaseInner);
  },

  get vModalFooter() {
    return joinCn(
      'flex items-center justify-end gap-1',
      'pt-2 pb-4',
      this.vModalBaseInner,
    );
  },
};

export default style;
